// This file was automatically generated from appshared.dialog.createLabResultVendor.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.createLabResultVendor');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.createLabResultVendor.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="create-lab-result-vendor" class="el8DialogContainer ebs-form-horizontal"><div class="el8FieldSection ebs-form-group"><label class="el8FieldLong ebs-control-label ebs-col-sm-4">Vendor Name:</label><div class="el8FieldLongLabelPadding el8TextareaWrap ebs-col-sm-8 padr0"><textarea type="text" class="w100 ebs-form-control" name="vendorName"></textarea></div></div><p class="el8AppText el8FieldLongLabelPadding el8Wrap ebs-col-sm-8 ebs-col-sm-offset-4 padr0">Note: A new vendor will be added to the list of available vendors.</p></form>');
  if (!opt_sb) return output.toString();
};
